import React from 'react';
import { View } from 'react-native';
import { Typography } from '../../typography/Typography';
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema';
const RecommendedAssetRepository = ({ height }) => {
    return (React.createElement(View, { style: {
            borderRadius: 4,
            paddingHorizontal: 8,
            paddingVertical: 2,
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            backgroundColor: "#E7F4ED"
        } },
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: 'Recommended', color: ColorTokens.Secondary_300 })));
};
export default RecommendedAssetRepository;
